import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Lock, ArrowRight } from "@phosphor-icons/react";
import { toast } from "sonner";
import { adminApi, setToken, getToken, formatApiError } from "../lib/adminApi";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (getToken()) return <Navigate to="/admin/waitlist" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !password) {
      toast.error("Email and password required.");
      return;
    }
    try {
      setLoading(true);
      const { data } = await adminApi.post("/auth/login", {
        email: email.trim(),
        password,
      });
      setToken(data.token);
      toast.success("Welcome back.");
      navigate("/admin/waitlist", { replace: true });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main
      data-testid="admin-login-page"
      className="min-h-screen bg-[#0a0705] flex items-center justify-center px-6"
    >
      <div className="grain absolute inset-0 pointer-events-none" />
      <div className="relative z-10 w-full max-w-md">
        <div className="flex justify-center mb-10">
          <img
            src="/logo-wordmark.png"
            alt="Kim Monroe LLC"
            className="h-16 w-auto"
          />
        </div>

        <div className="border border-white/10 bg-[#140E0B]/70 backdrop-blur-xl p-10">
          <div className="flex items-center gap-3 mb-6">
            <Lock size={18} weight="thin" className="text-[#E6CC98]" />
            <span className="text-xs uppercase tracking-[0.3em] gold-text font-body">
              Atelier Access
            </span>
          </div>
          <h1 className="font-heading font-light text-4xl text-[#FDFBF7] leading-tight mb-2">
            Sign in.
          </h1>
          <p className="text-sm text-[#A39791] font-body mb-8">
            Admin dashboard for Kim Monroe LLC.
          </p>

          <form
            onSubmit={onSubmit}
            data-testid="admin-login-form"
            noValidate
            className="space-y-4"
          >
            <div>
              <label className="text-[10px] uppercase tracking-[0.25em] text-[#A39791] font-body mb-2 block">
                Email
              </label>
              <input
                type="text"
                inputMode="email"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@kimmonroellc.com"
                data-testid="admin-email-input"
                className="glass-input w-full px-5 py-3.5 text-base font-body"
              />
            </div>
            <div>
              <label className="text-[10px] uppercase tracking-[0.25em] text-[#A39791] font-body mb-2 block">
                Password
              </label>
              <input
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                data-testid="admin-password-input"
                className="glass-input w-full px-5 py-3.5 text-base font-body"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              data-testid="admin-login-submit"
              className="btn-gold w-full px-6 py-4 text-xs uppercase tracking-[0.3em] flex items-center justify-center gap-2 disabled:opacity-60 mt-6"
            >
              {loading ? "Signing in..." : "Enter Dashboard"}
              <ArrowRight size={16} weight="bold" />
            </button>
          </form>
        </div>

        <p className="text-center mt-8 text-xs text-[#A39791]/60 font-body uppercase tracking-[0.25em]">
          © {new Date().getFullYear()} Kim Monroe LLC
        </p>
      </div>
    </main>
  );
}
